// client/src/App.js
import React, { useState, useEffect } from "react";
import Table from "./Table";

function App() {
  const [data, setData] = useState([]);

  // Пример получения данных с бэкенда
  useEffect(() => {
    fetch("https://admin.angry-spence.212-227-79-42.plesk.page/api/data")
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="App">
      <h1>Моя таблица</h1>
      <Table data={data} />
    </div>
  );
}

export default App;
